// deps
import { useCallback, useContext } from "react";
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

// contexts
import { PaymentPayContext } from "@payment-client/contexts/PaymentPayContext";
import { useBillImageHalfCardContext } from "@payment-client/contexts/BillImageHalfCardContext";

// interfaces
import { RequestForBillImageParams } from "@swiggy-private/payment-ui";

/**
 * Hook that provides the requestForBillImage method using the bill image half card context
 * @returns requestForBillImage function that can be used to trigger bill image upload
 */
export const useRequestForBillImage = () => {
    const { billTotal } = useContext(PaymentPayContext);
    const { open: openBillImageHalfCard } = useBillImageHalfCardContext();

    const requestForBillImage = useCallback(
        (params: RequestForBillImageParams) => {
            const { balance, onBillImagesUpdated, source } = params;

            try {
                return openBillImageHalfCard?.({
                    context: JSON.stringify({
                        billAmount: billTotal,
                        source,
                        balance,
                    }),
                    onBillImagesUpdated,
                });
            } catch (error) {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.REQUEST_FOR_BILL_IMAGE_ERROR,
                    error: error instanceof Error ? error.name : JSON.stringify(error),
                });
                return;
            }
        },
        [openBillImageHalfCard, billTotal],
    );

    return { requestForBillImage };
};
